module.exports = __webpack_public_path__ + "img/grain.8a23a188.svg";